import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }) => {
  commit(types.STRUCTURE_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-structure/")
    .then((response) => {
      commit(types.STRUCTURE_TOGGLE_LOADING);
      commit(types.STRUCTURE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.STRUCTURE_TOGGLE_LOADING);
      commit(types.STRUCTURE_SET_ERROR, e.message);
    });
};
